import { render, staticRenderFns } from "./ProposalFilters.vue?vue&type=template&id=6fded8ca&scoped=true"
import script from "./ProposalFilters.vue?vue&type=script&lang=js"
export * from "./ProposalFilters.vue?vue&type=script&lang=js"
import style0 from "./ProposalFilters.vue?vue&type=style&index=0&id=6fded8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fded8ca",
  null
  
)

export default component.exports